// api.js
import axios from 'axios'
import store  from '@/store'
import bertini from '@/api/bertini'
const timeout = store.getters.timeout

export default {

bertini,

post : json => axios({
        url      : process.env.VUE_APP_ROOT_API + "api/sp",               
        method   : 'post',
        data     : json,
        headers  : {'Authorization' : 'Bearer ' + store.getters.token},
        timeout  : timeout
        
        /*
        onDownloadProgress: function (progressEvent) {
          console.log(Math.round((progressEvent.loaded / progressEvent.total) * 100))
          // Do whatever you want with the native progress event
        },
        */
      }).then(res => {
        
        //console.log('SP API',res)
        return res

      }).catch(err => {
        
        if(err.response)
        {
          console.log('ERRORE API RESPONSE',err)
          return err.response
        }
        console.log('ERRORE API MESSAGE',err)
        return err.message
      })
      .finally(() => {})
,

  promise : (json)  => {
  return new Promise( (resolve, reject)  =>  {
  axios({
  url      : process.env.VUE_APP_ROOT_API + "api/sp",               
  method   : 'post',
  data     : json,
  headers  : {'Authorization' : 'Bearer ' + store.getters.token},
  timeout  : timeout              
  
}).then(res => {
  
  //console.log('SP API resolve',res)
  resolve(res)

}).catch(err => {
  
  if(err.response)
  {
    //console.log('ERRORE API RESPONSE',err)
    reject(err.response)
  }
  //console.log('ERRORE API MESSAGE',err)
  reject(err.message)
})
.finally(() => {})
})
}
,


api1 : (json,url)  => {
  return new Promise( (resolve, reject)  =>  {
  axios({
 
  url      : url,
  method   : 'post',
  data     : json,
  //headers  : {'Authorization' : 'Bearer ' + store.getters.token},
  timeout  : timeout              
  
}).then(res => {
  
  //console.log('API1 resolve',res)
  resolve(res)

}).catch(err => {
  
  if(err.response)
  {
    console.log('ERRORE API1 RESPONSE',err)
    reject(err.response)
  }
    console.log('ERRORE API1 MESSAGE',err)
    reject(err)
})
.finally(() => {})
})
}
,
caposerio : (json,url)  => {
  const Basic       = 'Basic YXBpdGVzdEB0ZXN0Lml0OmFwaXRlc3QwMDE='  
  const api_key     = {'api_key' : 'caldura'}
  const data        = Object.assign(json, api_key)
  
  //const url         = 'https://odbn9zh143.execute-api.eu-central-1.amazonaws.com/prod/'

  return new Promise( (resolve, reject)  =>  {
  axios({
 
  url      : url ,
  method   : 'post',
  data     : data,
  headers  : {'Authorization' : Basic},

  timeout  : timeout              
  
}).then(res => {
  
  //console.log('API1 resolve',res)
  resolve(res)

}).catch(err => {
  
  if(err.response)
  {
    console.log('ERRORE API RESPONSE',err)
    reject(err.response)
  }
    console.log('ERRORE API MESSAGE',err)
    reject(err)
})
.finally(() => {})
})
}
,

/*
booking : (data) => axios({
        url      : 'https://push1-170806655659.europe-west1.run.app/booking' ,               
        method   : 'post',
        data     : JSON.stringify({ test: 123 }),
        headers: {
      "Content-Type": "application/json"
    }
        
      }).then(res => {
        console.log('MSG DA SERVER',res.data)
        return res
      }).catch(err => {
        if(err.response)
        {
          console.log('MSG DA SERVER',err.response)
          return err.response
        }
       
        return err.message
      })
      .finally(() => {}),


*/





     
      shopifyCreateProductVariants : (companyId,productId) => {
        return new Promise( (resolve, reject)  =>  {
        axios({
        url      : process.env.VUE_APP_ROOT_API1 + 'sync/shopify/product/variants/' + companyId + '/' + productId ,               
        method   : 'get',
       
              
      }).then(res => {
        console.log('Shopify response ',res.data)
        resolve(res.data)

      }).catch(err => {
        if(err.response)
        {
          //console.log('MSG DA SERVER',err.response)
          resolve(err.response)

          
        }
        
        resolve(err.message)
      })
      .finally(() => {})

    })

  }
     

     
  


}
